var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var MARKDOWN_REGEXES = [
  /(#+)(.*)/,
  /\[([^\[]+)\]\(([^\)]+)\)/,
  // eslint-disable-line
  /(\*\*|__)(.*?)\1/,
  /(\*|_)(.*?)\1/,
  /\~\~(.*?)\~\~/,
  // eslint-disable-line
  /\:\"(.*?)\"\:/,
  // eslint-disable-line
  /`(.*?)`/,
  /\n\*(.*)/,
  /\n[0-9]+\.(.*)/,
  /\n(&gt;|\>)(.*)/,
  // eslint-disable-line
  /\n-{5,}/
  // /\n([^\n]+)\n/, // this is commented out because in some cases we have multiple new lines in text
];
function isStringMarkdown(text) {
  var index = 0;
  var length = MARKDOWN_REGEXES.length;
  while (index < length) {
    var regex = new RegExp(MARKDOWN_REGEXES[index]);
    if (regex.test(text)) {
      return true;
    }
    index += 1;
  }
  return false;
}
__name(isStringMarkdown, "isStringMarkdown");
export {
  isStringMarkdown
};
